import createReactComponent from '../createReactComponent';
export default createReactComponent('alt', 'Alt', [["path",{"d":"M3 5.25h5.625l6.75 13.5H21m-6.75-13.5H21","key":"svg-0"}]]);